import React , {useState} from 'react';
import {Domain} from "../Constants/Domain"
import axios from "axios"
import Footer from '../components/Footer/Footer';
import PageNavbar from '../components/Navbar/PageNavbar';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link
  } from "react-router-dom";
const Oxygensupplycontact = () => {

    
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [pincode, setPincode] = useState("");
    const [city, setCity] = useState("")
    const [cylinders, setCylinders] = useState("")

    const handleSubmit = async (e) => {
        e.preventDefault();

        const Data = {
            Name: name,
            Phone_no: phone ,
            City: city,
            Pincode: pincode,
            No_of_Cylinders: cylinders
        }
        try {
            const res = await axios.post(Domain + "Oxygen" , Data)

          console.log(res.data)
          
          }
          catch (err) {
            console.log(err)
          }  
    }

  return (
      <div className="oxygensupplycontact">
          <PageNavbar/>
          <div className="container mt-5 p-4">
            <form className="border border-info border-4 rounded-3 p-4 mb-5" onSubmit={handleSubmit}>
                <h1 className="display-6 fw-bold mark text-center mb-5">
                    Share Oxygen Supplier Information
                </h1>
            
                <div className="form mb-4">
                  <label for="floatingInput" className="p-1"><b>Name *</b></label>
                  <input type="text" className="form-control" id="floatingInput" value={name} onChange={(e) => {setName(e.target.value)}} />
                </div>

                <div className="form mb-4">
                    <label for="floatingInput" className="p-1"><b>Phone Number *</b></label>
                    <input type="text" maxlength="10" className="form-control" id="floatingInput" placeholder="10 Digits only..." value={phone} onChange={(e) => {setPhone(e.target.value)}} />
                </div>

                <div className="form mb-4">
                    <label for="floatingInput" className="p-1"><b>Pincode</b></label>
                    <input type="text" className="form-control" id="floatingInput" placeholder="enter your pincode" value={pincode} onChange={(e) => {setPincode(e.target.value)}}/>
                </div>

                <div className="form mb-4">
                    <label for="floatingInput" className="p-1"><b>No of Cylinders</b></label>
                    <input type="number" className="form-control" id="floatingInput" placeholder="enter no of cylinders" value={cylinders} onChange={(e) => {setCylinders(e.target.value)}}/>
                </div>

                <div className="form mb-4">
                    <label for="inputState" className="form-label"><b>Choose your City *</b></label>
                    <select id="inputState" className="form-select p-2" value={city} onChange={(e) => {setCity(e.target.value)}}>
                        <option selected>Select City</option>
                        <option>Mumbai</option>
                        <option>Delhi</option>
                        <option>Bangalore</option>
                        <option>Ahmedabad</option>
                        <option>Hyderabad</option>
                        <option>Chennai</option>
                        <option>Kolkata</option>
                        <option>Surat</option>
                        <option>Pune</option>
                        <option>Jaipur</option>
                        <option>Lucknow</option>
                        <option>Indore</option>
                        <option>Thane</option>
                        <option>Agra</option>
                        <option>Ghaziabad</option>
                    </select>
                </div>

                <div className="form-check mb-5">
                    <input className="form-check-input" type="checkbox" value="" id="invalidCheck" required/>
                    <label className="form-check-label" for="invalidCheck">
                      I hereby Agree to Terms and Conditions
                    </label>
                    <div className="invalid-feedback">
                      You must agree before submitting.
                    </div>
                </div>

                <button className="d-grid gap-2 col-12 mx-auto w-80 btn btn-primary mb-3 border border-none" href="#" role="button" type="submit" style={{"background-color": "#650013"}}>
                    Submit
                </button>
                
                <Link to="/oxygensupply" className="d-grid gap-2 col-12 mx-auto w-80 btn btn-info"  role="button">
                    View All Oxygen Suppliers
                </Link>
            </form>
        </div>

          <Footer/>
      </div>
  );
};

export default Oxygensupplycontact;
